function initMobileSwiper(selector) {
  if (window.innerWidth < 825) {
    const el = document.querySelector(selector);
    if (!el) {
      console.log('[Swiper Debug] Element not found:', selector);
      return;
    }

    if (el.swiper) {
      try { el.swiper.destroy(true, true); } catch (e) { }
    }

    const swiper = new Swiper(selector, {
      loop: false,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      touchStartPreventDefault: false,
      preventClicks: false,
      preventClicksPropagation: false,
      noSwiping: false,
      touchEventsTarget: 'container',
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: `${selector} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `${selector} .swiper-button-next`,
        prevEl: `${selector} .swiper-button-prev`,
      },
      on: {
        touchStart: function (s, e) {
          if (document.activeElement && document.activeElement.tagName === 'BUTTON') {
            document.activeElement.blur();
          }
        },
        slideChange: function () {
          // Sync thumbnails when swiper changes
          const sectionId = selector.replace('#swiper-mobile-media-', '');
          const thumbList = document.getElementById(`ThumbnailList-${sectionId}`);
          if (thumbList) {
            const index = this.realIndex;
            const items = thumbList.querySelectorAll('li');
            items.forEach((li) => li.classList.remove('is-active'));
            if (items[index]) {
              items[index].classList.add('is-active');
              const btn = items[index].querySelector('button');
              if (btn) {
                thumbList.scrollTo({ left: items[index].offsetLeft, behavior: 'smooth' });
              }
            }
          }
        }
      }
    });

    // Attach click listeners to thumbnails to move Swiper
    const sectionId = selector.replace('#swiper-mobile-media-', '');
    const thumbList = document.getElementById(`ThumbnailList-${sectionId}`);
    if (thumbList) {
      const items = thumbList.querySelectorAll('li');
      items.forEach((item, index) => {
        item.addEventListener('click', () => {
          if (el.swiper) {
            el.swiper.slideTo(index);
          }
        });
      });
    }

    return swiper;
  }
}

if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;
        if (event.target.name === 'sizepanel-measurement') return;

        this.resetProductFormState();

        // Smart Variant Resolution: find the guaranteed valid variant before fetching
        let targetVariantId = null;
        const variantSelects = this.querySelector("variant-selects");
        const variantsScript = variantSelects?.querySelector(
          "script[data-product-variants]"
        );

        if (variantsScript) {
          try {
            const allVariants = JSON.parse(variantsScript.textContent);
            const resolved = this.resolveBestVariant(allVariants, variantSelects, target);
            if (resolved) {
              targetVariantId = resolved.id;
            }
          } catch (e) {
            console.error("Variant resolve error:", e);
          }
        }

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;
        const sizeErrorEl = this.querySelector(
          ".product-form__error-message-wrapper-variant"
        );

        if (sizeErrorEl) sizeErrorEl.style.display = "none";
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            shouldSwapProduct ? [] : selectedOptionValues,
            shouldFetchFullPage,
            shouldSwapProduct ? null : targetVariantId
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      getOptionPosition(input, fieldsetIndex, optionPositions) {
        if (!input) return fieldsetIndex + 1;
        // Method 1: extract from name like "color-1-product-form-..."
        const match = (input.name || "").match(/-(\d+)-/);
        if (match) return parseInt(match[1], 10);

        // Method 2: extract from data-option-positions
        if (optionPositions) {
          const rawName = (input.name || "").split("-")[0].trim().toLowerCase();
          if (optionPositions[rawName]) return optionPositions[rawName];
        }

        // Method 3: fieldset index fallback
        return fieldsetIndex + 1;
      }

      resolveBestVariant(allVariants, variantSelects, targetInput) {
        if (!allVariants || !allVariants.length || !targetInput) return null;

        const normalize = (s) => (s ? String(s).trim().toLowerCase() : "");

        let optionPositions = null;
        const posScript = variantSelects.querySelector("script[data-option-positions]");
        if (posScript) {
          try {
            optionPositions = JSON.parse(posScript.textContent);
          } catch (e) {}
        }

        // 1. Collect currently selected option values by option position
        const selectedByPos = {};
        let targetPos = null;

        const fieldsets = variantSelects.querySelectorAll("fieldset.product-form__input");
        fieldsets.forEach((fieldset, idx) => {
          const isTargetFs = fieldset.contains(targetInput);
          const sampleInput = isTargetFs
            ? targetInput
            : fieldset.querySelector('input[type="radio"]:not(.toggle-radio)');
          const pos = this.getOptionPosition(sampleInput, idx, optionPositions);

          if (isTargetFs) {
            targetPos = pos;
            selectedByPos[pos] = targetInput.value;
          } else {
            const checked = fieldset.querySelector(
              'input[type="radio"]:checked:not(.toggle-radio)'
            );
            if (checked) {
              selectedByPos[pos] = checked.value;
            }
          }
        });

        if (!targetPos) {
          targetPos = this.getOptionPosition(targetInput, 0, optionPositions);
        }
        const targetVal = targetInput.value;

        // Check 1: Exact positional match (option1, option2, option3)
        const exactMatch = allVariants.find((v) => {
          for (const pos in selectedByPos) {
            const val = selectedByPos[pos];
            if (val && normalize(v["option" + pos]) !== normalize(val)) {
              return false;
            }
          }
          return true;
        });
        if (exactMatch) return exactMatch;

        // Check 2: Must match targetPos + targetVal, and Color (option1) if present
        const colorVal = selectedByPos[1];
        let candidates = allVariants.filter((v) => {
          const matchesTarget = normalize(v["option" + targetPos]) === normalize(targetVal);
          const matchesColor = !colorVal || normalize(v["option1"]) === normalize(colorVal);
          return matchesTarget && matchesColor;
        });

        if (candidates.length > 0) {
          return candidates.find((v) => v.available) || candidates[0];
        }

        // Check 3: If no candidates with color, match target position alone
        candidates = allVariants.filter(
          (v) => normalize(v["option" + targetPos]) === normalize(targetVal)
        );
        if (candidates.length > 0) {
          return candidates.find((v) => v.available) || candidates[0];
        }

        return null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false,
        variantId = null
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (variantId) {
          params.push(`variant=${variantId}`);
        } else if (optionValues && optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        const separator = url.includes("?") ? "&" : "?";
        return `${url}${separator}${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        let modalIsOpen = false;

        document.querySelectorAll(".quick-update-btn").forEach((radio) => {
          if (radio.hasAttribute("open")) {
            modalIsOpen = true;
          }
        });

        if (modalIsOpen) {
          console.log("is open data");
        } else {
          // FIX: Use this.querySelector to scope to current product-info element
          // instead of document.querySelector which grabs the first one on the page
          const oldvariantSelects = this.querySelector("variant-selects");

          // Safety check - if no variant selects found in this element, skip
          if (!oldvariantSelects) {
            if (variantSelects) {
              HTMLUpdateUtility.viewTransition(
                this.variantSelectors,
                variantSelects,
                this.preProcessHtmlCallbacks
              );
            }
            return;
          }

          // Keep fieldsets checked state properly synchronized
          variantSelects
            .querySelectorAll("fieldset.product-form__input")
            .forEach((newFieldset) => {
              const isColor = newFieldset.classList.contains("color-picker");
              const isSize = newFieldset.classList.contains("size-picker");
              const isLength = newFieldset.classList.contains("length-picker");

              let oldFieldset = null;
              if (isColor) oldFieldset = oldvariantSelects.querySelector(".color-picker");
              else if (isSize) oldFieldset = oldvariantSelects.querySelector(".size-picker");
              else if (isLength) oldFieldset = oldvariantSelects.querySelector(".length-picker");
              else {
                const legend = newFieldset.querySelector("legend")?.textContent?.trim();
                oldFieldset = Array.from(oldvariantSelects.querySelectorAll("fieldset.product-form__input"))
                  .find((f) => f.querySelector("legend")?.textContent?.trim() === legend);
              }

              const oldCheckedRadio = oldFieldset?.querySelector('input[type="radio"]:checked:not(.toggle-radio)');
              const hadSelectionInOld = !!oldCheckedRadio;

              if (!hadSelectionInOld && !isColor) {
                // If user hadn't selected anything in this non-color fieldset on initial load, keep it unchecked
                // UNLESS this fieldset has only 1 radio (single size / single length), in which case it must be checked!
                const visibleRadios = Array.from(
                  newFieldset.querySelectorAll('input[type="radio"]:not(.toggle-radio)')
                ).filter((r) => r.offsetParent !== null);

                if (visibleRadios.length > 1) {
                  newFieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
                    radio.checked = false;
                    radio.removeAttribute("checked");
                  });
                } else if (visibleRadios.length === 1) {
                  visibleRadios[0].checked = true;
                  visibleRadios[0].setAttribute("checked", "checked");
                }
              } else if (oldCheckedRadio) {
                // User had a selection. Does that value still exist in the new options?
                const matchingNewRadio = Array.from(newFieldset.querySelectorAll('input[type="radio"]'))
                  .find((r) => r.value === oldCheckedRadio.value);
                if (matchingNewRadio) {
                  newFieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
                    if (radio === matchingNewRadio) {
                      radio.checked = true;
                      radio.setAttribute("checked", "checked");
                    } else {
                      radio.checked = false;
                      radio.removeAttribute("checked");
                    }
                  });
                } else {
                  // The old selection doesn't exist for the new variant (e.g. Length 32 deleted for Waist 29)
                  // Keep whatever Liquid marked as checked for this valid variant!
                  const liquidChecked = newFieldset.querySelector('input[type="radio"][checked]');
                  if (liquidChecked) {
                    liquidChecked.checked = true;
                  }
                }
              }
            });

          const sizeCheckedInput = variantSelects.querySelector(
            '.size-picker input[type="radio"]:checked:not(.toggle-radio)'
          );
          variantSelects.querySelectorAll("#selected-size").forEach((span) => {
            if (sizeCheckedInput) {
              span.textContent = " " + sizeCheckedInput.value;
              span.style.display = "inline";
            } else {
              span.style.display = "none";
            }
          });

          const lengthCheckedInput = variantSelects.querySelector(
            '.length-picker input[type="radio"]:checked:not(.toggle-radio)'
          );
          variantSelects.querySelectorAll("#selected-length").forEach((span) => {
            if (lengthCheckedInput) {
              span.textContent = " " + lengthCheckedInput.value;
              span.style.display = "inline";
            } else {
              span.style.display = "none";
            }
          });
        }
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.updateVariantInputsUpdate(variant?.id, variant);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id, variant?.id);
          this.updateWishlist();

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              if (id == "product-udpate-price") {
                const oldVariantDiv = document.getElementById("old-variant-id");
                let oldVariantId = oldVariantDiv
                  ? oldVariantDiv.textContent.trim()
                  : null;


                let isUpdateOpen = false;

                document.querySelectorAll(".quick-update-btn").forEach((radio) => {
                  if (radio.hasAttribute("open")) {
                    isUpdateOpen = true;
                    console.log(radio);
                    const variId = radio.querySelector("#old-variant-id");
                    console.log(variId);
                    oldVariantId = variId ? variId.textContent.trim() : null;
                    console.log(oldVariantId, "old variant id");
                  }
                });





                // Parse source.innerHTML as a temporary DOM
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = source.innerHTML;
                // Select the first button (or all buttons if needed)
                const button = tempDiv.querySelector(".update-button-quick-modal");


                if (button) {
                  const variant_Id = button.getAttribute("data-variant-id");
                  console.log(variant_Id, oldVariantId);
                  if (variant_Id != oldVariantId) {
                    button.classList.remove("disabled");
                    button.removeAttribute("disabled");
                  } else {
                    button.classList.add("disabled");
                    button.removeAttribute("disabled");
                  }
                }

                // Update destination.innerHTML with modified HTML
                destination.innerHTML = tempDiv.innerHTML;
                destination.classList.toggle("hidden", shouldHide(source));
              } else {
                destination.innerHTML = source.innerHTML;
                destination.classList.toggle("hidden", shouldHide(source));
              }
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("product-price");
          updateSourceFromDestination("product-udpate-price");

          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination("Sku-Accordion-Main", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination("Sku-Accordion", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );

          updateSourceFromDestination("QuantityDropdown");

          const qtyWrapper = this.querySelector(`#QuantityDropdown-${this.dataset.section}`);
          if (qtyWrapper) {
            const select = qtyWrapper.querySelector(`select#Quantity-${this.dataset.section}`);
            if (select) {
              // read stock (server set data-stock) as a number
              const stock = parseInt(select.dataset.stock || select.options.length || 0, 10);
              // disable/enable and toggle blur class based on stock
              select.disabled = stock <= 0;
              select.classList.toggle("qtyDistabledDropdown", stock <= 0);
            }
          }

          // then existing theme logic continues
          this.updateQuantityRules(this.sectionId, html);

          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantInputsUpdate(variantId, variant) {
        // Select all product-info components inside the modal
        const input = document.querySelector("#variant-id-input");

        if (input) {
          // if (input.value !== String(variantId)) {
          input.value = variantId ?? "";
          // }
        }

        const wishlistBtn = document.querySelector(".wishlist-btn"); // "Add to List" button
        const addedBtn = document.querySelector(".remove-list"); // "Added to List!" button

        let wishlist = JSON.parse(localStorage.getItem("myWishlist")) || [];

        // Show correct button on load
        if (wishlist.some((item) => item.variantColor == variant?.option2 || item.idvariantColor == variant?.option2)) {
          if (wishlistBtn) wishlistBtn?.classList?.add("!hidden");
          if (addedBtn) addedBtn?.classList?.remove("!hidden");
        } else {
          if (wishlistBtn) wishlistBtn.classList.remove("!hidden");
          if (addedBtn) addedBtn.classList.add("!hidden");
        }



      }

      // updateURL(url, variantId) {
      //   this.querySelector("share-button")?.updateUrl(
      //     `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
      //   );

      //   if (this.dataset.updateUrl === "false") return;
      //   window.history.replaceState(
      //     {},
      //     "",
      //     `${url}${variantId ? `?variant=${variantId}` : ""}`
      //   );
      // }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;

        const currentUrl = new URL(window.location.href);
        const hasAppView = currentUrl.searchParams.has("app-view");

        const newUrl = new URL(`${window.location.origin}${url}`);
        if (variantId) newUrl.searchParams.set("variant", variantId);

        // Preserve the app-view=true parameter if it exists
        if (hasAppView) {
          newUrl.searchParams.set(
            "app-view",
            currentUrl.searchParams.get("app-view")
          );
        }

        // Preserve any other unrelated query params or hash fragments
        currentUrl.searchParams.forEach((value, key) => {
          if (!newUrl.searchParams.has(key) && key !== "variant") {
            newUrl.searchParams.set(key, value);
          }
        });
        newUrl.hash = currentUrl.hash;

        // Update browser history without reloading
        window.history.replaceState({}, "", newUrl.toString());
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.soldOut
        );

        const selectors = [
          "price",
          "Inventory",
          "product-price",
          "product-udpate-price",
          "Sku",
          "Sku-Accordion-Main",
          "Sku-Accordion",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
          "QuantityDropdown"
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }


      updateMedia(html, variantFeaturedMediaId, variantId) {
        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const mobilemediaGallerySource = this.querySelector(
          `#swiper-mobile-media-${this.dataset.section}`
        );

        const swiperDestinationSelector = `#swiper-mobile-media-${this.dataset.section}`.replace("quickadd-", "");
        const mobilemediaGalleryDestination = html.querySelector(swiperDestinationSelector);

        if (mobilemediaGallerySource && mobilemediaGalleryDestination) {
          if (mobilemediaGallerySource.swiper) {
            try { mobilemediaGallerySource.swiper.destroy(true, true); } catch (e) { }
          }

          mobilemediaGallerySource.innerHTML =
            mobilemediaGalleryDestination.innerHTML;

          void mobilemediaGallerySource.offsetHeight;

          setTimeout(() => {
            initMobileSwiper(`#swiper-mobile-media-${this.dataset.section}`);
          }, 0);
        }

        const container = html.querySelector("#side-guide-modal-opener");
        const oldcontainer = document.querySelector("#side-guide-modal-opener");

        document
          .querySelectorAll("#side-guide-modal-opener")
          .forEach((nodeOfModal) => {
            if (nodeOfModal && container) {
              nodeOfModal.innerHTML = container.innerHTML;
            }
          });


        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // Add new items
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // Remove old items
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // Refresh source if changed
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // Reorder items to match new destination
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        // --- Active media handling ---
        if (variantFeaturedMediaId) {
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );
        } else {
          // If no variant media, reset first slide as active
          const firstSlide = this.querySelector("media-gallery ul li");
          if (firstSlide) {
            this.querySelectorAll("media-gallery ul li").forEach((slide) =>
              slide.classList.remove("is-active")
            );
            firstSlide.classList.add("is-active");
          }
        }

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;

        // ✅ update thumbnail list
        const thumbnailSource = this.querySelector(
          `#ThumbnailList-${this.dataset.section}`
        );
        const thumbnailDestination = html.querySelector(
          `#ThumbnailList-${this.dataset.section}`
        );

        if (thumbnailSource && thumbnailDestination) {
          thumbnailSource.innerHTML = thumbnailDestination.innerHTML;
        }

        const modal = document.querySelector(".quick-add-modal[open]");
        if (!modal) return; // no modal is open

        if (!modal) return;

        if (modal) {
          const selectorkey = `#ThumbnailList-${this.dataset.section}`.replace(
            "quickadd-",
            ""
          );

          const thumbnailSourcemodal = modal.querySelector(
            `#ThumbnailList-${this.dataset.section}`
          );

          const thumbnailDestination = html.querySelector(selectorkey);
          if (thumbnailSourcemodal && thumbnailDestination) {
            thumbnailSourcemodal.innerHTML = thumbnailDestination.innerHTML;
          }

          if (thumbnailSourcemodal) {
            // ✅ Add "is-active" to the first li
            const firstLi = thumbnailSourcemodal.querySelector("li");
            if (firstLi) {
              // remove "is-active" from all li before adding to first
              thumbnailSourcemodal
                .querySelectorAll("li.is-active")
                .forEach((li) => li.classList.remove("is-active"));

              firstLi.classList.add("is-active");
            }
          }
          const oldVariantDiv = document.getElementById("old-variant-id");
          const oldVariantId = oldVariantDiv
            ? oldVariantDiv.textContent.trim()
            : null;

          if (variantId != oldVariantId) {
            // Select all buttons inside the modal
            const buttons = modal.querySelectorAll("button");
            buttons.forEach((btn) => {
              // Remove the disabled attribute
              if (btn.hasAttribute("disabled")) {
                btn.removeAttribute("disabled");
              }
              // Optional: remove any class that visually disables the button
              btn.classList.remove(
                "disabled",
                "opacity-50",
                "cursor-not-allowed"
              ); // Tailwind example
            });
          }
        }
      }
      updateWishlist() {
        const labels = document.querySelectorAll(".swatch-input__label");

        labels.forEach((label) => {
          label.addEventListener("click", function () {
            // Get the color name from the visually-hidden span (exclude sold-out span)
            const colorNameSpan = this.querySelector(
              ".visually-hidden:not(.label-unavailable)"
            );
            const colorName = colorNameSpan
              ? colorNameSpan.textContent.trim()
              : "Unknown";

            // Optionally get the variant ID from the associated input
            const inputId = this.getAttribute("for");
            const input = document.getElementById(inputId);
            const variantId = input ? input.dataset.variantId : "Unknown";

            const wishlistBtn = document.querySelector(".wishlist-btn"); // "Add to List" button
            const addedBtn = document.querySelector(".remove-list"); // "Added to List!" button

            let wishlist = JSON.parse(localStorage.getItem("myWishlist")) || [];

            // Show correct button on load
            if (wishlist.some((item) => item.variantId == variantId)) {
              if (wishlistBtn) wishlistBtn.classList.add("!hidden");
              if (wishlistBtn) addedBtn.classList.remove("!hidden");
            } else {
              if (wishlistBtn) wishlistBtn.classList.remove("!hidden");
              if (addedBtn) addedBtn.classList.add("!hidden");
            }
          });
        });
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        return fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === ".quantity__label") {
              const updatedAriaLabelledBy =
                updated.getAttribute("aria-labelledby");
              if (updatedAriaLabelledBy) {
                current.setAttribute("aria-labelledby", updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent =
                    updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
